/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { ApiQuestionType } from './types';

export interface QuestionTypeOption {
  type: ApiQuestionType;
  name: string;
}

const questionTypes: QuestionTypeOption[] = [
  {
    type: 'additional_text',
    name: 'Additional text',
  },
  {
    type: 'checkboxes',
    name: 'Checkboxes',
  },
  {
    type: 'date',
    name: 'Date',
  },
  {
    type: 'datetime',
    name: 'Datetime',
  },
  {
    type: 'email',
    name: 'Email',
  },
  {
    type: 'file_upload',
    name: 'File upload',
  },
  {
    type: 'radio',
    name: 'Radio buttons',
  },
  {
    type: 'rich_text',
    name: 'Rich text',
  },
  {
    type: 'text_field',
    name: 'Text field',
  },
  {
    type: 'url',
    name: 'URL',
  },
];

export default questionTypes;
